<style>
#dropzone {
  font-family: "Arial", sans-serif;
  letter-spacing: 0.2px;
  width: 100%;
  background: rgba(234, 235, 237, 0.75);
}
.dropzone.dz-started .dz-message {
  display: block !important;
}
.dropzone-custom-title {
  margin-top: 0;
  color: #009e4f;
}
.subtitle {
  color: #314b5f;
}
#dropzone > div.dz-preview.dz-file-preview,
#dropzone > div.dz-preview.dz-file-preview.dz-processing.dz-success {
  height: 30px !important;
}
#dropzone > div.dz-preview.dz-file-preview > div.dz-details {
  background-color: #009e4f !important;
}
#dropzone
  > div.dz-preview.dz-file-preview.dz-processing.dz-error.dz-complete
  > div.dz-details {
  background-color: #ff5b57 !important;
}
#dropzone.auto > div.dz-preview.dz-file-preview > a {
  top: 10px;
  right: 10px;
  bottom: none;
  border: none;
  text-decoration: none;
  font-size: 14px !important;
  height: 25px;
  padding: 0;
}
#dropzone.auto .dz-preview {
  display: none !important;
}
.dz-remove {
  right: 10px !important;
  padding: 5px !important;
}
</style>

<template>
  <!-- <div v-if="module == 'addAttachmentsToObjects' || $can('edit', module + '_attachments')"> -->
  <div v-if="true">
    <!-- Wiem, że głupie - tymczasowo do testów -->
    <v-subheader class="font--primary">DODAWANIE ZAŁĄCZNIKÓW</v-subheader>
    <v-layout>
      <vue-dropzone
        ref="attachmentDropzone"
        id="dropzone"
        :class="{ auto: auto }"
        :options="options"
        :useCustomSlot="true"
        @vdropzone-sending="sendingEvent"
        @vdropzone-error="sendingError"
        @vdropzone-success="sendingCompleted"
        @vdropzone-file-added="fileAdded"
        @vdropzone-files-added="changeBtnLang"
        @vdropzone-queue-complete="globalComplete"
        @vdropzone-removed-file="fileRemoved"
      >
        <div class="dropzone-custom-content">
          <h3
            class="dropzone-custom-title font--primary"
            style="color:rgb(42,87,154)"
          >
            Przeciągnij załączniki do wysłania
          </h3>
          <div class="subtitle font--primary">
            lub kliknij i wybierz je ze swojego komputera
          </div>
        </div>
      </vue-dropzone>
    </v-layout>
    <template v-if="!auto">
      <v-layout row wrap justify-end>
        <v-flex xs1>
          <v-icon
            class="table__btn--green btn-process-attachments"
            @click="sendFiles"
            >cloud_upload</v-icon
          >
          <v-icon
            class="table__btn--red btn-process-attachments"
            @click="clearFiles"
            >cancel</v-icon
          >
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import _ from "lodash/wrapperLodash";
import map from "lodash/map";

export default {
  props: {
    auto: Boolean,
    id_: {
      type: Number,
      required: false
    },
    objectTable: {
      type: String,
      required: false
    },
    objectType: {
      type: String,
      required: false
    },
    objects: {
      type: Array,
      required: false
    },
    module: {
      type: String,
      required: false
    },
    isAttachmentToObject: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    const self = this;
    return {
      attachID: undefined,
      dialog: false,
      attachmentId: undefined,
      options: {
        url: `${this.$store.getters.getApiURL}/attachments?token=${this.$store.getters.getToken}`,
        /* url: this.isAttachmentToObject ? `${this.$store.getters.getApiURL}/attachments/${this.attachID}?token=${
          this.$store.getters.getToken
          }` : `${this.$store.getters.getApiURL}/attachments?token=${
          this.$store.getters.getToken
          }`, */
        addRemoveLinks: true,
        success: function(file, response) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            `Pomyślnie dodano nowy załącznik o ID: ${response.attachments[0]}`
          );
        },
        autoProcessQueue: this.auto,
        maxFiles: 5,
        parallelUploads: 3,
        method: "post"
      }
    };
  },
  methods: {
    removeAllFiles(e) {
      this.$refs.attachmentDropzone.removeAllFiles(true);
      e.preventDefault();
    },
    sendingEvent(file, xhr, formData) {
      formData.append("filename", file.name);
      if (this.objects) {
        let objects = _.map(this.objects, object => ({
          object_id: object.object_id,
          object_table: object.object_table,
          object_type: object.object_type
        }));
        formData.append("objects", JSON.stringify(objects));
      } else if (this.objectTable) {
        formData.append(
          "objects",
          JSON.stringify([
            {
              object_id: this.id_,
              object_table: this.objectTable,
              object_type: this.objectType
            }
          ])
        );
      } else {
        formData.append(
          "objects",
          JSON.stringify([
            {
              object_id: this.id_,
              object_type: this.objectType
            }
          ])
        );
      }
    },
    sendingError(file, message, xhr) {
      this.$emit("sendingError");
      return false;
    },
    sendingCompleted(file, response) {
      if (this.isAttachmentToObject) {
        let payload = {
          objects: _.map(this.objects, object => ({
            object_id: object.object_id,
            object_table: object.object_table,
            object_type: object.object_type
          }))
        };
        this.$store
          .dispatch("addAttachmentToObject", [response.attachments[0], payload])
          .then(r => {
            if (r.status != 200) {
              this.$root.$emit("showSnackbar", "red", `${r.data.message}`);
              return false;
            } else {
              this.$root.$emit(
                "showSnackbar",
                "success",
                "Pomyślnie dodano załącznik do zaznaczonych obiektów"
              );
              this.$emit("attachmentAdded");
              return true;
            }
          });
      } else {
        this.$emit("attachmentAdded");
        return true;
      }
    },
    fileAdded(file) {
      this.$emit("fileAdded");
      return true;
    },
    fileRemoved(file, error, xhr) {
      this.$emit("fileRemoved");
      return true;
    },
    changeBtnLang(file) {
      for (let el of document.querySelectorAll(".dz-remove")) {
        el.innerText = "Usuń";
      }
      for (let el of document.querySelectorAll(".dz-complete > a")) {
        el.innerText = "Usuń";
      }
    },
    downloadAttachment(attachmentId, attachmentName) {
      let payload = {
        id: attachmentId,
        filename: attachmentName
      };
      this.$store.dispatch("downloadAttachment", payload).then(success => {
        if (success) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie pobrano załącznik"
          );
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania załącznika wystąpił błąd"
          );
        }
      });
    },
    globalComplete() {
      this.$root.$emit("addedAttachmentsGlobal");
    },
    deleteAttachment(attachmentId) {
      const self = this;
      this.attachemntId = attachmentId;
      this.$emit("confDialogOpened", true);

      self.$modal.show("dialog", {
        title: "Usuwanie załącznika",
        text: "Czy na pewno chcesz usunąć załącznik?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$store
                .dispatch("removeAttachment", self.attachemntId)
                .then(success => {
                  if (success) {
                    self.$root.$emit(
                      "showSnackbar",
                      "success",
                      "Pomyślnie usunięto załącznik"
                    );
                    self.$emit("attachmentDeleted");
                    self.$root.$emit("deletedAttachmentGlobal");
                  } else {
                    self.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Podczas usuwania załącznika wystąpił błąd"
                    );
                  }
                });
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
            }
          }
        ]
      });
    },

    sendFiles() {
      this.$refs.attachmentDropzone.processQueue();
    },
    clearFiles() {
      this.$refs.attachmentDropzone.removeAllFiles();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/AddAttachment.vue